import { RefObject, useEffect, useState } from 'react';
import { debounce } from 'lodash';

interface RefSize {
    height?: number;
    width?: number;
}

const useGetRefSize = (ref: RefObject<HTMLElement>, debounceDelay = 150): RefSize => {
    const [refSize, setRefSize] = useState<RefSize>({});

    useEffect(() => {
        if (!ref.current) {
            return;
        }

        const onResize = (entries: ResizeObserverEntry[]) => {
            const entry = entries[0];
            if (entry) {
                setRefSize({ height: entry.contentRect.height, width: entry.contentRect.width });
            }
        };
        const debounceResize = debounce(onResize, debounceDelay);

        const resizeObserver = new ResizeObserver(debounceResize);

        resizeObserver.observe(ref.current);

        return () => {
            resizeObserver.disconnect();
            debounceResize.cancel();
        };
    }, [ref, debounceDelay]);

    return refSize;
};

export default useGetRefSize;
